// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_WIKI_AI_REVIEW_SUMMARY_SUMMARIZED_FROM = ["Shrnuto pomoc\u00ed AI z %(count)s recenze", "Shrnuto pomoc\u00ed AI z %(count)s recenz\u00ed", "Shrnuto pomoc\u00ed AI z %(count)s recenz\u00ed"];
export const WIKI_AI_REVIEW_SUMMARY_BADGE = "Shrnut\u00ed hodnocen\u00ed";
export const WIKI_AI_REVIEW_SUMMARY_DISCLAIMER = "Automatick\u00e9 shrnut\u00ed hodnocen\u00ed generovan\u00e9 um\u011blou inteligenc\u00ed";
export const WIKI_AI_REVIEW_SUMMARY_DRAFT = "Nezve\u0159ejn\u011bno \u00b7 jen pro adminy";
export const WIKI_AI_REVIEW_SUMMARY_HIDE = "Skr\u00fdt";
export const WIKI_AI_REVIEW_SUMMARY_NEGATIVES = "Nej\u010dast\u011bj\u0161\u00ed z\u00e1pory";
export const WIKI_AI_REVIEW_SUMMARY_POSITIVES = "Nej\u010dast\u011bj\u0161\u00ed klady";
export const WIKI_AI_REVIEW_SUMMARY_SHOW = "Zobrazit cel\u00e9 shrnut\u00ed";
